import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', 'access-level');
        return response;
    } catch (e) { }
}


export async function getAccessLevel(id: string) {
    try {
        const response = await apiGet('core', `access-level/${id}`);

        return response.content;
    } catch (e) {
        return {};
    }
}

export async function accessLevelAdd(accessLevelBody: any) {
    try {
        const restOperation = await apiPost('core', 'access-level', accessLevelBody);

        const { body } = await restOperation.response;
        const response = await body.json();
        return response;
    } catch (e) { }
}

export async function accessLevelUpdate(accessLevelBody: any, id: string) {
    try {
        const restOperation = await apiPut('core', `access-level/${id}`, accessLevelBody);

        const { body } = await restOperation.response;
        const response = await body.json();
        return response;
    } catch (e) { }
}

export async function accessLevelRemove(id: any) {
    try {
        const restOperation = await apiDelete('core', `access-level/${id}`);

        return await restOperation.response;
    } catch (e) { }
}